import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { FILTERS } from '../constant';
import { FilterFields } from "../types";

const useGlobalSeachFlags = () => {
  const { generalConfig: { globalSearch } } = useSelector((state: RootState) => state.configReducer);
  const isGlobalSearchEnabled = globalSearch?.enabled;
  const listFilterScope: {[key in FilterFields]: boolean | undefined} = {
    [FILTERS.ALL.value]: globalSearch?.filterScope?.all,
    [FILTERS.MANAGE.value]: globalSearch?.filterScope?.manage,
    [FILTERS.KNOWLEDGE.value]: globalSearch?.filterScope?.knowledge,
    [FILTERS.ASSET.value]: globalSearch?.filterScope?.myTeam,
    [FILTERS.MARKETPLACE.value]: globalSearch?.filterScope?.marketplace,
    [FILTERS.SERVICES.value]: globalSearch?.filterScope?.services
  };

  return {
    isGlobalSearchEnabled,
    listFilterScope
  };
};

export default useGlobalSeachFlags;
